/** DjiniousData — the data platform behind data.djinious.com. */
export const BRAND = "DjiniousData";

/**
 * The descriptor says what the product IS, so the wordmark alone answers it.
 * The short form exists because the full one is ~2.3x wider and would push the
 * header into a horizontal scroll on a phone — see Nav.tsx.
 */
export const WORDMARK_SUB = "Ingestion · Ontology · Knowledge graph · Agents";
export const WORDMARK_SUB_SHORT = "API-first data platform";

export const NAV_LINKS: { label: string; to: string }[] = [
  { label: "Platform", to: "/platform" },
  { label: "Intelligence", to: "/intelligence" },
  { label: "AI & agents", to: "/ai" },
  { label: "Governance", to: "/governance" },
];

export const FOOTER_TAGLINE =
  "Ingest what you already have, model it as your own domain rather than ours, and keep every conclusion attached to the rows it was computed from.";

/**
 * The four stages of the pipeline. These are the page's structural spine: the
 * rail in the left margin, the section markers, and the order of the argument
 * all come from here. They are the product's real stages — each names modules
 * that exist (`server/ingest`, `server/ontology`, `server/resolve` +
 * `server/graph`, `server/analyze` + `server/alerts`) — not invented chapters.
 */
export const LOOP_STAGES = [
  { id: "ingest", label: "Ingest", note: "Files, connectors, streams" },
  { id: "model", label: "Model", note: "Ontology, defined at runtime" },
  { id: "resolve", label: "Resolve", note: "Entities, edges, evidence" },
  { id: "act", label: "Act", note: "Dashboards, alerts, agents" },
] as const;

export type LoopStageId = (typeof LOOP_STAGES)[number]["id"];

/** Where the app itself lives — the "sign in" destination, not a marketing page. */
export const APP_URL = "https://djinious-data.djinious.xyz";

/** Where the demo form POSTs. Override with VITE_DEMO_ENDPOINT to swap delivery later. */
export const DEMO_ENDPOINT =
  (import.meta.env.VITE_DEMO_ENDPOINT as string | undefined) ?? "/api/demo-request";
